(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-ilovej-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('ilovejForm');
  const phoneInput = document.getElementById('phone');
  const emailInput = document.getElementById('email');
  const consentCheckbox = document.getElementById('consent');
  const submitBtn = document.getElementById('submitBtn');
  const formWrapper = document.getElementById('formWrapper');
  const successScreen = document.getElementById('successScreen');

  phoneInput.addEventListener('input', function(e) {
    let value = e.target.value.replace(/\D/g, '');
    
    if (value.startsWith('63')) {
      if (value.length > 12) value = value.slice(0, 12);
      e.target.value = '+' + value;
    } else if (value.startsWith('9')) {
      if (value.length > 10) value = value.slice(0, 10);
      e.target.value = '09' + value;
    } else {
      if (value.length > 11) value = value.slice(0, 11);
      e.target.value = value;
    }
  });

  function validateForm() {
    let isValid = true;
    const errors = {
      phone: '',
      email: '',
      consent: ''
    };

    const phoneValue = phoneInput.value.trim();
    const phoneRegex = /^(09|\+639)[0-9]{9}$/;
    if (!phoneValue) {
      errors.phone = 'Phone number is required';
      isValid = false;
    } else if (!phoneRegex.test(phoneValue)) {
      errors.phone = 'Enter valid PH number (09XXXXXXXXX or +639XXXXXXXXX)';
      isValid = false;
    }

    const emailValue = emailInput.value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailValue) {
      errors.email = 'Email is required';
      isValid = false;
    } else if (!emailRegex.test(emailValue)) {
      errors.email = 'Enter valid email';
      isValid = false;
    }

    if (!consentCheckbox.checked) {
      errors.consent = 'You must consent';
      isValid = false;
    }

    document.getElementById('phoneError').textContent = errors.phone;
    document.getElementById('emailError').textContent = errors.email;
    document.getElementById('consentError').textContent = errors.consent;

    phoneInput.classList.toggle('error', !!errors.phone);
    emailInput.classList.toggle('error', !!errors.email);

    return isValid;
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Processing...';

    const formData = {
      phone: phoneInput.value.trim(),
      email: emailInput.value.trim(),
      consent: consentCheckbox.checked,
      marketing_optin: document.getElementById('marketing_optin').checked,
      campaign: 'ilovej-rainy-giveaway',
      timestamp: new Date().toISOString()
    };

    fetch('/cdn/shop/c/ilovej-form', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        formWrapper.style.display = 'none';
        successScreen.style.display = 'block';
        form.reset();
      } else {
        alert('Error: ' + (data.message || 'Failed to submit'));
        submitBtn.disabled = false;
        submitBtn.textContent = 'CLAIM YOUR VOUCHER';
      }
    })
    .catch(error => {
      console.error('Error:', error);
      alert('Network error. Please try again.');
      submitBtn.disabled = false;
      submitBtn.textContent = 'CLAIM YOUR VOUCHER';
    });
  });

  phoneInput.addEventListener('change', validateForm);
  emailInput.addEventListener('change', validateForm);
  consentCheckbox.addEventListener('change', validateForm);
});

  } catch(e) { console.error(e); }
})();
})();
